import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import { useIntl } from "react-intl";

const ConfirmPhysicalRoomDialog = ({ selectedRoom, handleCloseDialog }) => {
  const intl = useIntl();

  return (
    <Dialog
      open={!!selectedRoom}
      onClose={handleCloseDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {intl.formatMessage({
          id: "PhysicalRooms.ConfirmPhysicalRoomDialog.AccessTitle",
          defaultMessage: "Access the Room"
        })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {intl.formatMessage(
            {
              id: "PhysicalRooms.ConfirmPhysicalRoomDialog.AccessDescription",
              defaultMessage: "Do you want to access the room {roomName}?"
            },
            { roomName: selectedRoom ? selectedRoom.name : "" }
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} color="primary">
          {intl.formatMessage({
            id: "PhysicalRooms.ConfirmPhysicalRoomDialog.Cancel",
            defaultMessage: "Cancel"
          })}
        </Button>
        <Button
          component={RouterLink}
          to={`/physical_rooms/${selectedRoom.id}`}
          color="primary"
          autoFocus
        >
          {intl.formatMessage({
            id: "PhysicalRooms.ConfirmPhysicalRoomDialog.Access",
            defaultMessage: "Access"
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmPhysicalRoomDialog;
